import type { Payment } from '@/core/domain';
import type { ListPaymentsByUserOptions, PaymentsRepository } from '../repositories/payments-repository';

export class GetPaymentsByUserIdUseCase {
  constructor(private readonly repository: PaymentsRepository) {}

  async execute(userId: string, options?: ListPaymentsByUserOptions): Promise<Payment[]> {
    return this.repository.getAllByUserId(userId, options);
  }
}
